import type { CustomAgentJsonType } from '@bb/domain/dist/types/CustomAgent';
import axios, { type AxiosRequestConfig } from 'axios';

const update = async (
  customAgent: Omit<
    CustomAgentJsonType,
    | '_id'
    | 'id'
    | 'createdBy'
    | 'createdByRole'
    | 'org'
    | 'isDeleted'
    | 'updatedBy'
    | 'location'
    | 'team'
  >,
  customAgentId: string,
) => {
  const config: AxiosRequestConfig = {
    url: `/custom_agent/${customAgentId}`,
    method: 'post',
    data: customAgent,
  };

  const { data } = await axios.request<CustomAgentJsonType>(config);
  return data;
};
export default update;
